<div class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div>
      <h3 class="pl-3 mt-1 mb-0">System Users</h3>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-4 col-md col-lg-5 px-2 pb-2">
          <div class="form-group">
            <i>
              <span class="mr-2">Active Count : {{ activeCount }}</span>
              <span class="mr-2">Inactive Count : {{ inActiveCount }}</span>
              <span>Special Permission Count : {{ inSpecialPermission }}</span>
            </i>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control select2" #status (change)="searchInTable(status.value, 'status')">
              <option selected="selected" value="">Select All</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input type="text" id="status" (blur)="searchInTable(status.value, 'status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2">
          <div class="form-group">
            <label>Role</label>
            <select class="form-control select2" #role1 (change)="searchInTable(role1.value, 'role_id')">
              <option selected="selected" value="">Select All</option>
              <option *ngFor="let item of rolesData" [value]="item.id">{{ item.role_name }}</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input type="text" id="role1" (blur)="searchInTable(role1.value, 'role_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                #search
                class="form-control fild"
                (keyup)="handleSearch(search.value)" />
              <a href="javascript:;" class="search"><i class="fas fa-search"></i></a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2" *ngIf="userPermissions.system_users_setting.edit">
          <div class="search-box">
            <div class="form-group">
              <a href="javascript:;" class="btn btn-block btn-primary" (click)="generateCSV()">Export CSV</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2" *ngIf="userPermissions.system_users_setting.edit">
          <div class="form-group">
            <a
              href="javascript:;"
              data-toggle="modal"
              data-target="#create-user"
              class="btn btn-block btn-primary"
              (click)="setMode('Add')"
              >Add User</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table user-data-table mt-0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Alias</th>
        <th>Email</th>
        <th>Role</th>
        <th width="10%">Special Permission</th>
        <th class="text-right">Actions</th>
      </tr>
    </thead>
    <tbody *ngIf="usersData.length > 0">
      <tr *ngFor="let item of usersData">
        <td>{{ item.first_name }} {{ item.last_name }}</td>
        <td>{{ item.employee_alias }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.role_name }}</td>
        <td width="10%">
          <span style="display: none">{{ item.is_special_permissions }}</span
          ><span class="status-icon" *ngIf="item.is_special_permissions">
            <i class="far fa-check"></i>
          </span>
        </td>
        <td class="text-right">
          <!-- Rounded switch -->
          <label
            *ngIf="userPermissions.system_users_setting.view && userPermissions.system_users_setting.edit"
            class="switch mr-2">
            <input
              type="checkbox"
              data-toggle="modal"
              data-target="#change-status"
              (click)="setUserStatusId($event, item.id)"
              [checked]="item.status" />
            <span class="slider round"></span>
          </label>
          <a
            *ngIf="userPermissions.system_users_setting.view && userPermissions.system_users_setting.edit"
            href="javascript:;"
            class="mr-2 font-20"
            data-toggle="modal"
            data-target="#create-user"
            (click)="setMode('Edit', item.id)"
            ><i class="far fa-pen"></i
          ></a>
          <a
            *ngIf="userPermissions.system_users_setting.view && userPermissions.system_users_setting.edit"
            href="javascript:;"
            data-toggle="modal"
            data-target="#delete-user"
            title="Delete"
            class="font-20"
            (click)="setDeleteUserId(item.id)"
            ><i class="far fa-trash"></i
          ></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal fade" id="create-user">
  <div class="modal-dialog modal-xl">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit(userForm)">
      <div *ngIf="noDataMsg">
        {{ noDataMsg }}
      </div>
      <div class="modal-content jsUserForm">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ mode }} User: {{ userForm.get('first_name').value }} {{ userForm.get('last_name').value }}
          </h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <input type="hidden" *ngIf="mode == 'Edit'" class="form-control" name="id" formControlName="id" />
          <ul class="nav nav-tabs line-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" data-toggle="tab" href="#general-user" role="tab" aria-selected="true"
                >General</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#jobs-user" role="tab" aria-selected="false">Jobs</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#tool-pointe-user" role="tab" aria-selected="false"
                >ToolPointe</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#job-pointe-user" role="tab" aria-selected="false"
                >JobPointe</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#purchase-orders-user" role="tab" aria-selected="false"
                >PurchasePointe</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#settings-user" role="tab" aria-selected="false">Settings</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade show active" id="general-user" role="tabpanel">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>First Name<sup>*</sup></label>
                    <input
                      type="text"
                      class="form-control"
                      name="first_name"
                      id="userFName"
                      tabindex="1"
                      formControlName="first_name"
                      autofocus />
                    <span
                      class="error"
                      *ngIf="userForm.get('first_name').hasError('required') && userForm.get('first_name').touched">
                      Please provide first name
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Title<sup>*</sup></label>
                    <input
                      type="text"
                      class="form-control userTitle"
                      autofocus
                      readonly
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="title" />
                    <input type="hidden" name="title" class="userTitle" tabindex="3" formControlName="title" />
                  </div>
                  <div class="form-group">
                    <label>Phone</label>
                    <input
                      type="text"
                      class="form-control mobile-input-mask"
                      name="phone"
                      id="userPhone"
                      formControlName="phone"
                      tabindex="5"
                      autofocus
                      mask="(XXX) XXX-XXXX"
                      clearIfNotMatch="true" />
                  </div>
                  <div class="form-group">
                    <label>Alias</label>
                    <input
                      type="text"
                      class="form-control"
                      name="employee_alias"
                      id="userAlias"
                      formControlName="employee_alias"
                      tabindex="7"
                      autofocus />
                  </div>
                  <div class="form-group">
                    <label>Password<sup *ngIf="mode == 'Add'">*</sup></label>
                    <input
                      type="password"
                      class="form-control"
                      name="password"
                      formControlName="password"
                      id="userPassword"
                      tabindex="9" />
                    <span
                      class="error"
                      *ngIf="userForm.get('password').hasError('required') && userForm.get('password').touched">
                      Please provide password
                    </span>
                  </div>
                  <div class="form-group">
                    <span>* Required fields.</span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Last Name<sup>*</sup></label>
                    <input
                      type="text"
                      class="form-control"
                      name="last_name"
                      id="userLName"
                      tabindex="2"
                      formControlName="last_name"
                      autofocus />
                    <span
                      class="error"
                      *ngIf="userForm.get('last_name').hasError('required') && userForm.get('last_name').touched">
                      Please provide last name
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Role *</label>
                    <select
                      class="form-control"
                      formControlName="role_id"
                      #role_id
                      (change)="onOptionsSelected(userForm.get('role_id').value)"
                      tabindex="4">
                      <option [value]="null">Select All</option>
                      <option *ngFor="let item of rolesData" [ngValue]="item.id">
                        {{ item.role_name }}
                      </option>
                    </select>
                    <span
                      class="error"
                      *ngIf="userForm.get('role_id').hasError('required') && userForm.get('role_id').touched">
                      Please select role
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Email<sup>*</sup></label>
                    <input
                      type="text"
                      class="form-control"
                      autocomplete="off"
                      name="email"
                      id="userEmail"
                      formControlName="email"
                      tabindex="6" />
                    <span
                      class="error"
                      *ngIf="userForm.get('email').hasError('required') && userForm.get('email').touched">
                      Please provide email
                    </span>
                    <span class="error" *ngIf="userForm.get('email').hasError('email')">
                      Please provide valid email
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Select Status<sup>*</sup></label>
                    <select
                      class="form-control"
                      formControlName="status"
                      #status1
                      tabindex="8"
                      (change)="setDataToControl('status', status1.value)">
                      <option selected="selected">Status</option>
                      <option [value]="1">Active</option>
                      <option [value]="0">Inactive</option>
                    </select>
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input
                        type="text"
                        formControlName="status"
                        id="activeStatus"
                        (blur)="setDataToControl('status', status1.value)" />
                    </div>
                    <span
                      class="error"
                      *ngIf="userForm.get('status').hasError('required') && userForm.get('status').touched">
                      Please select status
                    </span>
                  </div>
                  <div class="form-group">
                    <label>PurchasePointe Access</label>
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        #ppAccess
                        id="ppAccessChk"
                        formControlName="pp_access" />
                      <label class="custom-control-label" for="ppAccessChk"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Jobs -->
            <div class="tab-pane fade" id="jobs-user" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="main_job_list">
                    <td>
                      <span class="text-black">Main Job List</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_view"
                          id="customCheck201"
                          formControlName="view"
                          (change)="setValue($event, 'main_job_list', 'view')" />
                        <label class="custom-control-label" for="customCheck201"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_edit"
                          id="customCheck202"
                          formControlName="edit"
                          (change)="setValue($event, 'main_job_list', 'edit')" />
                        <label class="custom-control-label" for="customCheck202"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="general_info">
                    <td>
                      <span class="text-black pl-3">General Info</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck203"
                          formControlName="view"
                          (change)="setValue($event, 'general_info', 'view')" />
                        <label class="custom-control-label" for="customCheck203"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck204"
                          formControlName="edit"
                          (change)="setValue($event, 'general_info', 'edit')" />
                        <label class="custom-control-label" for="customCheck204"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="billing_accounting">
                    <td>
                      <span class="text-black pl-3">Billing & Accounting</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck205"
                          formControlName="view"
                          (change)="setValue($event, 'billing_accounting', 'view')" />
                        <label class="custom-control-label" for="customCheck205"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck206"
                          formControlName="edit"
                          (change)="setValue($event, 'billing_accounting', 'edit')" />
                        <label class="custom-control-label" for="customCheck206"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="financials">
                    <td>
                      <span class="text-black pl-3">Financials</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck207"
                          formControlName="view"
                          (change)="setValue($event, 'financials', 'view')" />
                        <label class="custom-control-label" for="customCheck207"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck208"
                          formControlName="edit"
                          (change)="setValue($event, 'financials', 'edit')" />
                        <label class="custom-control-label" for="customCheck208"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="audit_trail">
                    <td>
                      <span class="text-black pl-3">Audit Trail</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck211"
                          formControlName="view"
                          (change)="setValue($event, 'audit_trail', 'view')" />
                        <label class="custom-control-label" for="customCheck211"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck212"
                          formControlName="edit"
                          (change)="setValue($event, 'audit_trail', 'edit')" />
                        <label class="custom-control-label" for="customCheck212"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="locked_fields">
                    <td>
                      <span class="text-black pl-3">Locked Fields</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck213"
                          formControlName="view"
                          (change)="setValue($event, 'locked_fields', 'view')" />
                        <label class="custom-control-label" for="customCheck213"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck214"
                          formControlName="edit"
                          (change)="setValue($event, 'locked_fields', 'edit')" />
                        <label class="custom-control-label" for="customCheck214"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="working_status">
                    <td>
                      <span class="text-black pl-3">Working Status</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck98"
                          formControlName="view"
                          (change)="setValue($event, 'working_status', 'view')" />
                        <label class="custom-control-label" for="customCheck98"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck99"
                          formControlName="edit"
                          (change)="setValue($event, 'working_status', 'edit')" />
                        <label class="custom-control-label" for="customCheck99"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="invoicing_list">
                    <td>
                      <span class="text-black">Invoicing</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck215"
                          formControlName="view"
                          (change)="setValue($event, 'invoicing_list', 'view')" />
                        <label class="custom-control-label" for="customCheck215"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck216"
                          formControlName="edit"
                          (change)="setValue($event, 'invoicing_list', 'edit')" />
                        <label class="custom-control-label" for="customCheck216"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="invoicing_reset">
                    <td>
                      <span class="text-black">Invoicing Reset</span>
                    </td>
                    <td></td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck255"
                          formControlName="edit"
                          (change)="setValue($event, 'invoicing_reset', 'edit')" />
                        <label class="custom-control-label" for="customCheck255"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="job_status">
                    <td>
                      <span class="text-black">Job Status</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck219"
                          formControlName="view"
                          (change)="setValue($event, 'job_status', 'view')" />
                        <label class="custom-control-label" for="customCheck219"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck220"
                          formControlName="edit"
                          (change)="setValue($event, 'job_status', 'edit')" />
                        <label class="custom-control-label" for="customCheck220"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="owner_info">
                    <td>
                      <span class="text-black">Owner Info</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck217"
                          formControlName="view"
                          (change)="setValue($event, 'owner_info', 'view')" />
                        <label class="custom-control-label" for="customCheck217"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck218"
                          formControlName="edit"
                          (change)="setValue($event, 'owner_info', 'edit')" />
                        <label class="custom-control-label" for="customCheck218"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="customers">
                    <td>
                      <span class="text-black">Customers</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck241"
                          formControlName="view"
                          (change)="setValue($event, 'customers', 'view')" />
                        <label class="custom-control-label" for="customCheck241"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck242"
                          formControlName="edit"
                          (change)="setValue($event, 'customers', 'edit')" />
                        <label class="custom-control-label" for="customCheck242"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Jobs End-->
            <!-- JobPointe -->
            <div class="tab-pane fade" id="job-pointe-user" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe">
                    <td class="text-black">Job Pointe</td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe', 'view')" />
                        <label class="custom-control-label" for="job_pointe_view"></label>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_board_attributes">
                    <td>
                      <span class="text-black pl-3">Job Board</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_board_attributes_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_board_attributes', 'view')" />
                        <label class="custom-control-label" for="job_board_attributes_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_board_attributes_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_board_attributes', 'edit')" />
                        <label class="custom-control-label" for="job_board_attributes_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="manage_jobs">
                    <td>
                      <span class="text-black pl-3">Manage Jobs</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="manage_jobs_view"
                          formControlName="view"
                          (change)="setValue($event, 'manage_jobs', 'view')" />
                        <label class="custom-control-label" for="manage_jobs_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="manage_jobs_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'manage_jobs', 'edit')" />
                        <label class="custom-control-label" for="manage_jobs_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe_employees">
                    <td>
                      <span class="text-black pl-3">Employees</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_employees_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe_employees', 'view')" />
                        <label class="custom-control-label" for="job_pointe_employees_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_employees_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_pointe_employees', 'edit')" />
                        <label class="custom-control-label" for="job_pointe_employees_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe_configuration">
                    <td>
                      <span class="text-black pl-3">Configuration</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_configuration_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe_configuration', 'view')" />
                        <label class="custom-control-label" for="job_pointe_configuration_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_configuration_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_pointe_configuration', 'edit')" />
                        <label class="custom-control-label" for="job_pointe_configuration_edit"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- JobPointe End -->
            <!-- ToolPointe -->
            <div class="tab-pane fade" id="tool-pointe-user" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Detailed View</th>
                    <th>Edit</th>
                    <th>Admin</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools">
                    <td>
                      <span class="text-black">Tools</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_view"
                          formControlName="view"
                          (change)="setValue($event, 'tools', 'view')" />
                        <label class="custom-control-label" for="tools_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tools', 'detailed_view')" />
                        <label class="custom-control-label" for="tools_detailed_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tools', 'edit')" />
                        <label class="custom-control-label" for="tools_edit"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_admin"
                          formControlName="admin"
                          (change)="setValue($event, 'tools', 'admin')" />
                        <label class="custom-control-label" for="tools_admin"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools_history">
                    <td>
                      <span class="text-black">Tool History</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_history_view"
                          formControlName="view"
                          (change)="setValue($event, 'tools_history', 'view')" />
                        <label class="custom-control-label" for="tool_history_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_history_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tools_history', 'detailed_view')" />
                        <label class="custom-control-label" for="tool_history_detailed_view"></label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tool_inventory">
                    <td>
                      <span class="text-black">Tool Inventory</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_inventory_view"
                          formControlName="view"
                          (change)="setValue($event, 'tool_inventory', 'view')" />
                        <label class="custom-control-label" for="tool_inventory_view"></label>
                      </div>
                    </td>
                    <td></td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_inventory_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tool_inventory', 'edit')" />
                        <label class="custom-control-label" for="tool_inventory_edit"></label>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tool_models">
                    <td>
                      <span class="text-black">Tool Models</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_view"
                          formControlName="view"
                          (change)="setValue($event, 'tool_models', 'view')" />
                        <label class="custom-control-label" for="tool_models_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tool_models', 'detailed_view')" />
                        <label class="custom-control-label" for="tool_models_detailed_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tool_models', 'edit')" />
                        <label class="custom-control-label" for="tool_models_edit"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_admin"
                          formControlName="admin"
                          (change)="setValue($event, 'tool_models', 'admin')" />
                        <label class="custom-control-label" for="tool_models_admin"></label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-black">Asset Classes</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr
                    class="permissions_form"
                    *ngFor="let assetClass of getAssetClasses() | keyvalue"
                    formGroupName="asset_class">
                    <td>
                      <span class="text-black pl-3"> {{ assetClass.key }}</span>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_view_{{ assetClass.key }}"
                          formControlName="view"
                          (change)="setAssetClassValue($event, assetClass.key, 'view')" />
                        <label class="custom-control-label" for="asset_class_view_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_detailed_view_{{ assetClass.key }}"
                          formControlName="detailed_view"
                          (change)="setAssetClassValue($event, assetClass.key, 'detailed_view')" />
                        <label
                          class="custom-control-label"
                          for="asset_class_detailed_view_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_edit_{{ assetClass.key }}"
                          formControlName="edit"
                          (change)="setAssetClassValue($event, assetClass.key, 'edit')" />
                        <label class="custom-control-label" for="asset_class_edit_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_admin_{{ assetClass.key }}"
                          formControlName="admin"
                          (change)="setAssetClassValue($event, assetClass.key, 'admin')" />
                        <label class="custom-control-label" for="asset_class_admin_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- ToolPointe End -->
            <!-- Purchase Orders-->
            <div class="tab-pane fade" id="purchase-orders-user" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="purchase_orders">
                    <td>
                      <span class="text-black">Purchase Orders</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="poViewChkBox"
                          formControlName="view"
                          (change)="setValue($event, 'purchase_orders', 'view')" />
                        <label class="custom-control-label" for="poViewChkBox"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="poEditChkBox"
                          formControlName="edit"
                          (change)="setValue($event, 'purchase_orders', 'edit')" />
                        <label class="custom-control-label" for="poEditChkBox"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="po_amount">
                    <td>
                      <span class="text-black pl-3">PO Amounts</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck21"
                          formControlName="view"
                          (change)="setValue($event, 'po_amount', 'view')" />
                        <label class="custom-control-label" for="customCheck21"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck222"
                          formControlName="edit"
                          (change)="setValue($event, 'po_amount', 'edit')" />
                        <label class="custom-control-label" for="customCheck222"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="material_request">
                    <td>
                      <span class="text-black">Material Request</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck223"
                          formControlName="view"
                          (change)="setValue($event, 'material_request', 'view')" />
                        <label class="custom-control-label" for="customCheck223"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck224"
                          formControlName="edit"
                          (change)="setValue($event, 'material_request', 'edit')" />
                        <label class="custom-control-label" for="customCheck224"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="receiving">
                    <td>
                      <span class="text-black">Receiving</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_view"
                          formControlName="view"
                          (change)="setValue($event, 'receiving', 'view')" />
                        <label class="custom-control-label" for="receiving_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'receiving', 'edit')" />
                        <label class="custom-control-label" for="receiving_edit"></label>
                      </div>
                    </td>
                  </tr>
                    <tr class="permissions_form" formGroupName="receiving_module_po_update_notify_owner">
                    <td>
                      <span class="text-black">PO Notifications</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_module_po_update_notify_owner_view"
                          formControlName="view"
                          (change)="setValue($event, 'receiving_module_po_update_notify_owner', 'view')" />
                        <label class="custom-control-label" for="receiving_module_po_update_notify_owner_view"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="accounting">
                    <td>
                      <span class="text-black">Accounting</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck225"
                          formControlName="view"
                          (change)="setValue($event, 'accounting', 'view')" />
                        <label class="custom-control-label" for="customCheck225"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck226"
                          formControlName="edit"
                          (change)="setValue($event, 'accounting', 'edit')" />
                        <label class="custom-control-label" for="customCheck226"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="sage_export">
                    <td>
                      <span class="text-black pl-3">Sage Export</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck227"
                          formControlName="view"
                          (change)="setValue($event, 'sage_export', 'view')" />
                        <label class="custom-control-label" for="customCheck227"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck228"
                          formControlName="edit"
                          (change)="setValue($event, 'sage_export', 'edit')" />
                        <label class="custom-control-label" for="customCheck228"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="jobs">
                    <td>
                      <span class="text-black">Jobs</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="jobsChkUser1"
                          formControlName="view"
                          (change)="setValue($event, 'jobs', 'view')" />
                        <label class="custom-control-label" for="jobsChkUser1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="jobsChkUser2"
                          formControlName="edit"
                          (change)="setValue($event, 'jobs', 'edit')" />
                        <label class="custom-control-label" for="jobsChkUser2"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="vendors">
                    <td>
                      <span class="text-black">Vendors</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck229"
                          formControlName="view"
                          (change)="setValue($event, 'vendors', 'view')" />
                        <label class="custom-control-label" for="customCheck229"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck230"
                          formControlName="edit"
                          (change)="setValue($event, 'vendors', 'edit')" />
                        <label class="custom-control-label" for="customCheck230"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="master_list">
                    <td>
                      <span class="text-black">Master List</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="masterListUser1"
                          formControlName="view"
                          (change)="setValue($event, 'master_list', 'view')" />
                        <label class="custom-control-label" for="masterListUser1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="masterListUser2"
                          formControlName="edit"
                          (change)="setValue($event, 'master_list', 'edit')" />
                        <label class="custom-control-label" for="masterListUser2"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="settings">
                    <td>
                      <span class="text-black">Settings</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="settingsUser1"
                          formControlName="view"
                          (change)="setValue($event, 'settings', 'view')" />
                        <label class="custom-control-label" for="settingsUser1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="settingsUser2"
                          formControlName="edit"
                          (change)="setValue($event, 'settings', 'edit')" />
                        <label class="custom-control-label" for="settingsUser2"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Purchase Orders End -->
            <!-- Scheduling-->
            <div class="tab-pane fade" id="scheduling-user" role="tabpanel"></div>
            <!-- Scheduling End -->
            <!-- Safety -->
            <div class="tab-pane fade" id="safety-user" role="tabpanel"></div>
            <!-- Safety End -->
            <!-- Communication -->
            <div class="tab-pane fade" id="communication-user" role="tabpanel"></div>
            <!-- Communication End -->
            <!-- Employees -->
            <div class="tab-pane fade" id="employees-user" role="tabpanel"></div>
            <!-- Employees End -->
            <!-- Settings -->
            <div class="tab-pane fade" id="settings-user" formGroupName="permissions" role="tabpanel">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="roles_setting">
                    <td>
                      <span class="text-black">Roles</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_view"
                          id="customCheck71"
                          formControlName="view"
                          (change)="setValue($event, 'roles_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck71"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_edit"
                          id="customCheck72"
                          formControlName="edit"
                          (change)="setValue($event, 'roles_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck72"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="system_users_setting">
                    <td>
                      <span class="text-black">System Users</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck173"
                          formControlName="view"
                          (change)="setValue($event, 'system_users_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck173"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck174"
                          formControlName="edit"
                          (change)="setValue($event, 'system_users_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck174"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="union_locals_setting">
                    <td>
                      <span class="text-black">Union Local</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck75"
                          formControlName="view"
                          (change)="setValue($event, 'union_locals_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck75"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck76"
                          formControlName="edit"
                          (change)="setValue($event, 'union_locals_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck76"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools_setting">
                    <td>
                      <span class="text-black">Tools Settings</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck175"
                          formControlName="view"
                          (change)="setValue($event, 'tools_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck175"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck176"
                          formControlName="edit"
                          (change)="setValue($event, 'tools_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck176"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="design_setting">
                    <td>
                      <span class="text-black">Design Settings</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck77"
                          formControlName="view"
                          (change)="setValue($event, 'design_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck77"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck78"
                          formControlName="edit"
                          (change)="setValue($event, 'design_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck78"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="smtp_setting">
                    <td>
                      <span class="text-black">SMTP</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck79"
                          formControlName="view"
                          (change)="setValue($event, 'smtp_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck79"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck80"
                          formControlName="edit"
                          (change)="setValue($event, 'smtp_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck80"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Settings End -->
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary button-eh mb-3" #closebutton data-dismiss="modal">Close</button>
          <input type="submit" class="btn btn-primary button-eh mb-3" value="Save" />
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Delete User Modal -->
<div class="modal fade" id="delete-user" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              <b>{{ userNames[deleteUserId] }}</b
              ><br />
              Are you sure you would like to delete this user?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton1 data-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="deleteUser(deleteUserId)">
            Delete User
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Delete User Modal End-->

<!-- Change User Status Modal -->
<div class="modal fade" id="change-status" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              <b>{{ userNames[statusUserId] }}</b
              ><br />
              Are you sure you want to change status?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            #closebutton2
            data-dismiss="modal"
            (click)="getUsers()">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="changeStatus(statusUserId, userStatus)">
            Change Status
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Change User Status Modal End-->
